<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import { INSTAGRAM_POST_TAG_PRODUCT_TYPE } from "@apps/instagram/constants";
    import type InstagramPostTagEntity from "@apps/instagram/entities/InstagramPostTagEntity";
    import { createInstagramPostReferrer } from "@apps/instagram/utils/createInstagramPostReferrer";
    import { createProductInfoObservable } from "@apps/instagram/utils/createProductInfoObservable";
    import { instagramGalleryWidgetContextToken } from "@apps/instagram/widgets/instagram_gallery_widget/context_tokens";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import Observable from "@ui-utils/Observable.svelte";

    import BasePostModalTagCard from "@components/PostModal/BasePostModalTagCard.svelte";
    import PostModalProductTagCard from "@components/PostModal/PostModalProductTagCard.svelte";

    export let activeMediaTags: InstagramPostTagEntity[];
    export let selectedTagId: number | null = null;
    export let productQuickViewEnabled: boolean;
    export let activePostId: number;

    const { productsQuery, urlsBuilder } = getTypedContext(
        instagramGalleryWidgetContextToken
    );

    $: isSelectedTagId = (tagId: number): boolean => selectedTagId === tagId;
</script>

<div class="gw-ig-post-modal-tags-list">
    {#if activeMediaTags}
        {#each activeMediaTags as tag (tag.id)}
            {#if tag.type === INSTAGRAM_POST_TAG_PRODUCT_TYPE}
                <Observable
                    observable={createProductInfoObservable(
                        productsQuery,
                        tag.product.id,
                        tag.variantId
                    )}
                    let:value
                >
                    {#if value.status === STATUS.READY}
                        <PostModalProductTagCard
                            on:tag_select
                            on:tag_unselect
                            on:tag_open
                            selected={isSelectedTagId(tag.id)}
                            {productQuickViewEnabled}
                            imageUrl={(value.variant?.image?.url &&
                                urlsBuilder.createProductImageUrl(
                                    value.variant?.image?.url
                                )) ||
                                (value.product.featuredImage?.url &&
                                    urlsBuilder.createProductImageUrl(
                                        value.product.featuredImage?.url
                                    ))}
                            comparePrice={value.variant?.compareAtPrice
                                ?.amount || null}
                            price={value.variant?.price?.amount ||
                                value.product.variants[0].price.amount}
                            tagId={tag.id}
                            title={value.product.title}
                            url={urlsBuilder.createProductUrl(
                                value.product.handle,
                                undefined,
                                createInstagramPostReferrer(activePostId)
                            )}
                            variantTitle={value.variant?.title}
                        />
                    {/if}
                </Observable>
            {:else}
                <BasePostModalTagCard
                    on:tag_select
                    on:tag_unselect
                    on:tag_open
                    tagId={tag.id}
                    selected={isSelectedTagId(tag.id)}
                    imageUrl={tag.link.linkImageUrl}
                    title={tag.link.title}
                    url={tag.link.linkUrl}
                />
            {/if}
        {/each}
    {/if}
</div>

<style>
    .gw-ig-post-modal-tags-list {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        display: grid;
        grid-gap: 16px;
        margin-top: 15px;
    }
    @media all and (max-width: 900px) {
        .gw-ig-post-modal-tags-list {
            grid-template-columns: 1fr 1fr;
        }
    }
    @media all and (max-width: 730px) {
        .gw-ig-post-modal-tags-list {
            grid-template-columns: 1fr;
        }
    }
</style>
